import React, { useState } from "react";
import "./process.scss";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import UnifiedCard from "./UnifiedCard";
import useProjectsData from "../../../hooks/sales/useProjectsData";

function SampleNextArrow(props) {
  const { className, onClick, hideArrow } = props;

  return !hideArrow ? (
    <div className={className} onClick={onClick}>
      <img
        src="\next-arrow.svg"
        alt="Next"
        className="img-fluid d-none show-in-light-theme"
      />
      <img
        src="\next-arrow-dark.svg"
        alt="Next"
        className="img-fluid hide-in-light-theme"
      />
    </div>
  ) : (
    <div
      className={className}
      onClick={onClick}
      style={{ pointerEvents: "none", opacity: "0.5" }}
    >
      <img
        src="\next-arrow.svg"
        alt="Next"
        className="img-fluid d-none show-in-light-theme"
      />
      <img
        src="\next-arrow-dark.svg"
        alt="Next"
        className="img-fluid hide-in-light-theme"
      />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick, hideArrow } = props;
  return !hideArrow ? (
    <div className={className} onClick={onClick}>
      <img
        src="\prev-icon.svg"
        alt="Prev"
        className="img-fluid d-none show-in-light-theme"
      />
      <img
        src="\prev-icon-dark.svg"
        alt="Prev"
        className="img-fluid hide-in-light-theme"
      />
    </div>
  ) : (
    <div
      className={className}
      onClick={onClick}
      style={{ pointerEvents: "none", opacity: "0.5" }}
    >
      <img
        src="\prev-icon.svg"
        alt="Prev"
        className="img-fluid d-none show-in-light-theme"
      />
      <img
        src="\prev-icon-dark.svg"
        alt="Prev"
        className="img-fluid hide-in-light-theme"
      />
    </div>
  );
}

const Process = () => {
  const { t } = useTranslation();
  const projectsData = useProjectsData();


  return (
    <>
      <section className="process-projects">
        <div className="custom-container padd-right-sm">
          <div className="bottom-cards">
            {/* {currentSlide >= totalSlides - 1 ? (
              <>
                <img
                  src="\cardshadow-light.png"
                  alt="img"
                  className="img-fluid cardshadow-lightleft d-none show-in-light-theme"
                />
                <img
                  src="\cardshadow-dark.png"
                  alt="img"
                  className="img-fluid cardshadow-lightleft hide-in-light-theme"
                />
              </>
            ) : (
              <>
                <img
                  src="\cardshadow-light.png"
                  alt="img"
                  className="img-fluid cardshadow-light d-none show-in-light-theme"
                />
                <img
                  src="\cardshadow-dark.png"
                  alt="img"
                  className="img-fluid cardshadow-light hide-in-light-theme"
                />
              </>
            )} */}
                {projectsData?.map((project) => (
                  <UnifiedCard key={project?.id} project={project} />
                ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Process;